export default __webpack_public_path__ + "static/media/Plus.31f05639.png";